import React from 'react';
import OdiseaLogo from '../../images/branding/odisea-logo.svg';
import TopArc from '../../images/main-banner/top-arc.svg';
import MainNav from '../navigation/main-nav';
import Social from '../social/social';

export default class ArticleTwo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
}

  render() {
    return (
      <div id={this.props.id} className='header-container'>
        <div className='flex-group flex-nowrap'>
          <MainNav />
          <img src={OdiseaLogo} className='odisea-logo' alt="" />
          <Social />
        </div>
        <img src={TopArc} className='top-arc' alt="" />
      </div>
    );
  }
}